import React, {PureComponent, Fragment} from "react"
import PropTypes from "prop-types"

import {Header, LocationsMapWrapper} from "./styled/Default"
import LocationsMap from "../../LocationsMap"

class Default extends PureComponent {
  static propTypes = {
    deal: PropTypes.shape({
      header: PropTypes.string.isRequired
    }).isRequired,
    locationsData: PropTypes.array.isRequired,
    selectedLocation: PropTypes.object
  }

  static defaultProps = {
    selectedLocation: null
  }

  render() {
    const {deal, locationsData, selectedLocation} = this.props
    const {header} = deal
    return (
      <Fragment>
        <Header>{header}</Header>
        <LocationsMapWrapper>
          <LocationsMap deal={deal} locationsData={locationsData} selectedLocation={selectedLocation} />
        </LocationsMapWrapper>
      </Fragment>
    )
  }
}

export default Default
